// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1Dsbd","modalForm":"UpgradeEpcsModal_modalForm__QHIkW","modalFooter":"UpgradeEpcsModal_modalFooter___TRMj"};